import { useEffect, useState } from 'react';
import { CacheProvider } from '@emotion/react';
// import { faFacebookF, faPinterestP, faTelegram, faTwitter, faWhatsapp } from '@fortawesome/free-brands-svg-icons';
// import { FrontAwesomeIcon } from '@fortawesome/react-frontawesome';

// import ShareIcon from '@mui/icons-material/Share';
// import Box from '@mui/material/Box';
// import Grid from '@mui/material/Grid';
// import IconButton from '@mui/material/IconButton';
// import Typography from '@mui/material/Typography';
import { convertEpochTime, getMUICache, getUrl, getImageId, getImageUrl, showMultipleAuthor, getImageSize, processArticleBodyAmp_New, getEndpoint, setCmsSeoData, getImageCreditString , GetIconsSprites, isCSR} from '../../../common/utils';
// import { SocialShare } from '../SocialShare/SocialShare';
import Tag from "../../Tag/Tag";
import './ArticleShowThreeAmp.css';
// import { Tweet } from 'react-twitter-widgets';
import bcrypt from 'bcryptjs-react';

import { PAGEBUILDER_URLS,URL_PROTOCAL } from '../../Common/Constant';
import React from 'react';

ArticleShowThreeAmp.version = 1000;
Object.defineProperty(ArticleShowThreeAmp, 'name', {
    writable: true,
    value: 'ArticleShowThreeAmp'
});

export function ArticleShowThreeAmp(props: any) {

    const { anchorLinksValue, showImageCredits } = props;

    let [allData, setAllData] = useState<any>({});
    let [articleData, setArticleData] = useState<any>({});
    const [authorData, setAuthorData] = useState<any>([]);
    const [heroImageData, setHeroImageData] = useState<any>({});
    const [tagsData, setTagsData] = useState<any>([]);
    let [embeds, setEmbeds] = useState<any>([]);
    let [cmsembeds, setCmsembeds] = useState<any>([]);
    const [agency, setAgency] = useState<any>('');
    let [completeBody, setCompleteBody] = useState<any>('');

    const endpoint = getEndpoint(props);
    const { showNewsAgency } = props;

    let REQUEST_HOSTNAME: any = null;
    if (props && props.REQUEST_HOSTNAME) {
        REQUEST_HOSTNAME = props.REQUEST_HOSTNAME;
    }
    let REQUEST_URL: any = null;
    if (props && props.REQUEST_URL) {
        REQUEST_URL = props.REQUEST_URL;
    }
    let shareUrl = URL_PROTOCAL + REQUEST_HOSTNAME + REQUEST_URL;
    let shareText = allData && allData?.it && allData?.it?.hl 
   
    useEffect(() => {
        if (!endpoint.isSSR || !endpoint.SSRDataObj) {
            fetchComponentData();
        }

        if (typeof window !== 'undefined' && window.gpEditor) {

            window.gpEditor.editor.on('component:selected', (component: any) => {
                if (component && component.attributes && component.attributes.type === "Article Show Three Amp") {
                    setTimeout(() => {
                        const trait = component.getTraits().find((tr: any) => tr.get('id') === "deviceType");
                        if (trait && trait.el) {
                            // Show trait element if showAdSlot is true, hide otherwise
                            trait.el.style.display = props.showAdSlot ? 'block' : 'none';
                        }
                    }, 200);
                }
            });

            const selected = window.gpEditor.getSelected();
            if (selected) {
                const trait = selected.getTraits().find((tr: any) => tr.get('id') === "deviceType");
                if (trait && trait.el) {
                    // Show trait element if showAdSlot is true, hide otherwise
                    trait.el.style.display = props.showAdSlot ? 'block' : 'none';
                }
            }
        }

    }, [endpoint, props.showAdSlot]);


    const setResponseOfAPI = (response: any) => {
        if (response && Object.keys(response).length > 0 && response.it && response.it != null) {
            if (typeof props.exportedKeys !== "undefined" && typeof props.exportedKeys.pid !== "undefined"
                && response.it.folderId != null && response.it.folderId != "") {
                props.exportedKeys.pid = response.it.folderId;
            }
            if (typeof props.exportedKeys !== "undefined" && typeof props.exportedKeys.sectionid !== "undefined"
                && response.it.id != null && response.it.id != "") {
                props.exportedKeys.sectionid = response.it.id;
            }
            if (typeof props.exportedKeys !== "undefined" && typeof props.exportedKeys.authorid !== "undefined"
                && typeof response.it.authors != "undefined" && response.it.authors.length > 0) {
                props.exportedKeys.authorid = response.it.authors[0].id;
            }
            if (typeof props.exportedKeys !== "undefined" && typeof props.exportedKeys.tags !== "undefined"
                && typeof response.it.kws != "undefined" && response.it.kws.length > 0) {
                const names = response.it.kws.map((item: any) => item.name).join(',');
                props.exportedKeys.tags = names;
            }
            setAllData(response);
            allData = response;
            let obj = {
                title: response.it.hl,
                permaLink: response.it.wu,
                summary: response.it.syn,
                tags: response.it.metaKws,
                body: response.it.processStory,
                publishedDate: response.it.published,
                updatedDate: response.it.updated,
                baseDomain: response.it.pubInfo.baseDomain
            };
            setCmsSeoData(props, response, "ArticleShowAmp");
            setArticleData(obj);
            articleData = obj;
            setAuthorData(response.it.authors);

            // setContributionType(response.it.contribution);
            setAgency(response.it.ag);

            let imageIdObj = response?.it?.imageid;
            if (props.hostImageId && (!imageIdObj || !(imageIdObj.includes('imagesize=') || imageIdObj.includes('imgsize='))) ) {
                imageIdObj = props.hostImageId;
            }

            let heroImageData = {
                alt: response.it.metaInfo && response.it.metaInfo.TitleOfTheImage,
                msid: getImageId(imageIdObj),
                imageCreditTxt: response.it.metaKews?.AgencyOfTheImage,
                imageAgency: response.it.metaKews?.TheCaptionOfTheImage,
                imageSize: getImageSize(imageIdObj),
                imageUrl: getImageUrl(getImageId(imageIdObj), getImageSize(imageIdObj), 616, undefined, response.it.pubInfo.baseDomain, false, props.CONSTANTS),
                imageMetaTitle: response?.it?.metaInfo && response?.it?.metaInfo?.TitleOfTheImage,
                imageMetaAuthor: response?.it?.metaInfo && response?.it?.metaInfo?.PhotographerByline,
                imageMetaAgency: response?.it?.metaInfo && response?.it?.metaInfo?.AgencyOfTheImage,
                imageSourceName: response?.it?.metaInfo && response?.it?.metaInfo?.ImageCreditSourceName
            }
            setHeroImageData(heroImageData);
            heroImageData = heroImageData;

            setTagsData(response.it.kws);
            setEmbeds(response.it.embeds);
            embeds = response.it.embeds;
            setCmsembeds(response.it.cmsembed);
            cmsembeds = response.it.cmsembed;


            //let undefinedVar;
            let bodySnippet: any = '';
            if (props.showAdSlot) {
                if (isCSR() && PAGEBUILDER_URLS.some(url => window.location.origin.includes(url))) {
                    bodySnippet = '<div class="container" style="display: flex; justify-content: center; align-items: center; width: 100%; height: 100%;"><div class="ad-box" style="width: 300px;height: 250px;display: flex;align-items: center;justify-content: center;background-color: #f0f0f0;">Ad Slot<br>300 X 250</div></div>'

                }
                else if (isCSR()) 
                    {
                        console.log("Only CSR AMP");
                        // if (clientDevice.isDesktop) {
                        //     bodySnippet = `<div id="ad-container">${props.bodyAdScript?.replace(/<script[^>]*>[\s\S]*?<\/script>/, "")}</div>`;
                        // } else if (clientDevice.isMobile) {
                        //     bodySnippet = `<div id="ad-container">${props.bodyAdMobileScript?.replace(/<script[^>]*>[\s\S]*?<\/script>/, "")}</div>`;
                        // }
                        bodySnippet = props?.data?.attributes?.adConfigurations;
                    }
                    else {
                        console.log("Only SSR AMP");
                        // bodySnippet = `<div></div>`;
                        bodySnippet = props?.data?.attributes?.adConfigurations;
                    }
            }
            setCompleteBody({ articleBody: articleData.body, embeds, cmsembeds, baseDomain: articleData.baseDomain, CONSTANTS: props.CONSTANTS, bodySnippet, adSize: props.adSize });
        }
    }

    if (endpoint.isSSR && endpoint.SSRDataObj && allData && Object.keys(allData).length === 0) {
        setResponseOfAPI(endpoint.SSRDataObj);
    }

    useEffect(() => {
        ////console.log("Props=> ", props);
    });


    const fetchComponentData = () => {
        getData(getUrl(props, 1, false, 'MAIN', true));
    }



    const getData = (url: any) => {
        ////console.log("Articleshow URL ::: " + url)

        let headerString = '?' + url.split("?")[1];
        headerString = bcrypt.hashSync(headerString, 6);
        const headers = { 'p-nonce': headerString };

        fetch(url, { headers: headers })
            .then((response) => response.json())
            .then(response => {
                setResponseOfAPI(response);
            })
            .catch(err => {
                //console.log("Exception => ", err);
            });
    }

    const showCredits = () => {
        let creditComponent = []
        const authorContent = showMultipleAuthor(authorData, allData?.it?.pubInfo.baseDomain)
        if (props.showAuthor && authorContent.length!=0) {
            creditComponent.push(authorContent)
        }
        if (showNewsAgency && agency && agency.length != 0) {
            creditComponent.push(agency)
        }
        let formattedDate = '';
        if (props.GLOBAL_DATA_COMPONENT && props.GLOBAL_DATA_COMPONENT?.dateTimeFormat && props.GLOBAL_DATA_COMPONENT?.publishedOrUpdated && articleData && Object.keys(articleData).length != 0) {
            if (props.GLOBAL_DATA_COMPONENT.publishedOrUpdated === 'updated') {
                formattedDate = convertEpochTime(articleData.updatedDate, '', props.GLOBAL_DATA_COMPONENT.dateTimeFormat) as string;
            } else if (props.GLOBAL_DATA_COMPONENT.publishedOrUpdated === 'published') {
                formattedDate = convertEpochTime(articleData.publishedDate, '', props.GLOBAL_DATA_COMPONENT.dateTimeFormat) as string;
            }
        }

        if (formattedDate && props.showDateTime) {
            creditComponent.push(formattedDate)
        }
        let creditStr = creditComponent.join(" | ")
        return <><span className='articalShowAuthr' dangerouslySetInnerHTML={{ __html: creditStr }} /></>
    }



    const getRenderPart = () => {
        return (
            <CacheProvider value={getMUICache()}>
                <div className='themeTwoAmpArticalWrapper'>
                    <div className='themeTwoAmpStoryDetails'>
                        <div className='themeTwoAmpStoryWrapper'>
                            <div className="card-box themeTwoAmpHeaderBox">
                                <h1 className="themeTwoAmpStoryHeading">
                                    {articleData?.title}
                                </h1>
                                <div className='themeTwoAmpContainerRow'>
                                    <div className='themeTwoAmpcolumCount'>
                                        <div className="themeTwoAmpstoryshowSubhead">
                                            <div className='themeTwoAmpHandleMobil'>
                                            {showCredits()}
                                               
                                            </div>

                                            <div className='themeTwoAmpArticalMedia'>

                                                <ul>
                                                    <li> <a className="toFb"
                                                        href={`https://www.facebook.com/sharer.php?u=${shareUrl}&quot;,&quot;top=100,left=500,width=600,height=600,location=no,fullscreen=no&quot;)`}
                                                        target="_blank">
                                                        {/* <FrontAwesomeIcon icon={faFacebookF} /> */}
                                                        <div className='bg-Facebook_icon_T3' style={{ backgroundImage: `url(${GetIconsSprites()})` }}></div>
                                                    </a></li>
                                                    <li><a className="toTwitter"
                                                        href={`https://twitter.com/intent/tweet?text=${shareText && shareText.substring(0, 100)}&url=${props.shareUrl}`}
                                                        target="_blank">
                                                         <div className='bg-X_icon_T3' style={{ backgroundImage: `url(${GetIconsSprites()})` }}></div>
                                                    </a></li>
                                                    <li><a className="wtsapp"
                                                        href={`https://api.whatsapp.com/send?text=${shareUrl}`}
                                                        target="_blank">
                                                        {/* <FrontAwesomeIcon icon={faWhatsapp} /> */}
                                                        <div className='bg-Whatsapp_icon_T3' style={{ backgroundImage: `url(${GetIconsSprites()})` }}></div>
                                                    </a>
                                                    </li>
                                                    <li> <a className="toPinterest"
                                                        href={`https://in.pinterest.com/pin/create/button?url=${shareUrl}&quot;,&quot;top=100,left=500,width=600,height=600,location=no,fullscreen=no&quot;)`}
                                                        target="_blank">
                                                        <div className='bg-Pinterest_icon_T3' style={{ backgroundImage: `url(${GetIconsSprites()})` }}></div>
                                                    </a></li>
                                                    <li>
                                                        <a className="toLinkedIn"
                                                            href={`https://www.linkedin.com/sharing/share-offsite?url=${shareUrl}`} target="_blank">
                                                            {/* <FoontAwesomeIcon icon={faPinterestP} /> */}
                                                            <div className='bg-in_icon_T3' style={{ backgroundImage: `url(${GetIconsSprites()})` }}></div>
                                                        </a>
                                                    </li>
                                                    {/* <li> <a className="toTelegram"
                                                        href={`https://telegram.me/share/url?url=${shareUrl}&quot;,&quot;top=100,left=500,width=600,height=600,location=no,fullscreen=no&quot;)`}
                                                        target="_blank">
                                                        <FrontAwesomeIcon icon={faTelegram} />
                                                    </a></li> */}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                            <div className="card-box themeTwoAmpImgBox">
                                {heroImageData && heroImageData.imageSize &&
                                    (<div className='themeTwoAmpMobileImage'>
                                        {heroImageData && heroImageData.imageSize &&
                                            React.createElement('div', { className: 'themeTwoAmpMainImg' },
                                                React.createElement('amp-img', {
                                                    src: heroImageData?.imageUrl,
                                                    alt: heroImageData.alt,
                                                    title: heroImageData.alt,
                                                    width: "600",
                                                    height: "400",
                                                    layout: "responsive"
                                                })
                                            )
                                        }

                                    </div>)
                                }
                            </div>

                            { showImageCredits && heroImageData && heroImageData.imageSize && 
                                (<div className='ampCommonImagecreditMainWrapper themeThreeAmpCommonImagecreditMainWrapper'>
                                    {/* <div className='ampCommonImageCeditTitle'>{heroImageData.imageMetaTitle}</div> */}
                                    <div className='ampCommonImageCeditAgencyAuth'>{getImageCreditString(heroImageData.imageMetaAgency, heroImageData.imageMetaAuthor, heroImageData.imageSourceName, allData?.it?.pubInfo?.channel)}</div>
                                </div>)                                   
                            }

                            <div className="AthemeTwoAmprticleSummary">
                                <p><strong>Highlight of the story:</strong> <span dangerouslySetInnerHTML={{ __html: articleData?.summary || '' }} /></p>
                            </div>
                            
                            <div className='themeTwoAmpImagecaWrap'>
                                {/* <div className="card-box themeTwoAmpImgCredit">
                                    Photo: <span>{heroImageData?.imageCreditTxt}</span>
                                </div> */}
                                <div className="card-box IthemeTwoAmpmgAgency">
                                    <span>{heroImageData?.imageAgency}</span>
                                </div>
                            </div>
                            <div className="card-box themeTwoAmpSynopsis">{articleData ? articleData.synopsis : ''}</div>

                            <div className="card-box themeTwoAmpAsContentBody">
                                {completeBody &&
                                    <div className='themeTwoAmpTypographyamp'>
                                        {/* {renderBody(completeBody)} */}
                                        {/* <span dangerouslySetInnerHTML={{ __html: completeBody }} /> */}
                                        {processArticleBodyAmp_New(completeBody.articleBody, completeBody.embeds, completeBody.cmsembeds, completeBody.baseDomain, completeBody.CONSTANTS, completeBody.bodySnippet, completeBody.adSize, allData?.it?.pubInfo.channel, showImageCredits)}
                                    </div>
                                }
                            </div>
                            <div className='themeTwoAmpContainerRow'>
                                <div className='themeTwoAmpColumCount'>
                                    {props.showTags && <Tag baseDomain={allData?.it?.pubInfo.baseDomain} tagsData={tagsData} anchorLinksValue={anchorLinksValue}/>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </CacheProvider>
        );
    }

    return (
        <CacheProvider value={getMUICache()}>
            {getRenderPart()}
        </CacheProvider>
    )
}

